var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8359 11.1523L9.01172 1.19922C8.76562 0.816406 8.38281 0.625 8 0.625C7.58984 0.625 7.20703 0.816406 6.96094 1.19922L1.10938 11.1523C0.699219 11.918 1.24609 12.875 2.14844 12.875H13.8242C14.7266 12.875 15.2734 11.918 14.8359 11.1523ZM2.42188 11.5625L7.97266 2.07422L13.5508 11.5625H2.42188ZM8 8.99219C7.50781 8.99219 7.125 9.375 7.125 9.83984C7.125 10.3047 7.50781 10.6875 8 10.6875C8.46484 10.6875 8.84766 10.3047 8.84766 9.83984C8.84766 9.375 8.46484 8.99219 8 8.99219ZM7.34375 4.78125V7.40625C7.34375 7.78906 7.61719 8.0625 8 8.0625C8.35547 8.0625 8.65625 7.78906 8.65625 7.40625V4.78125C8.65625 4.42578 8.35547 4.125 8 4.125C7.61719 4.125 7.34375 4.42578 7.34375 4.78125Z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningV2);
export default __webpack_public_path__ + "static/media/warning-v2.7c7393559331688da1a384b7cdfea945.svg";
export { ForwardRef as ReactComponent };